import { render, staticRenderFns } from "./CameraAgente.vue?vue&type=template&id=2105502f&"
import script from "./CameraAgente.vue?vue&type=script&lang=js&"
export * from "./CameraAgente.vue?vue&type=script&lang=js&"
import style0 from "./CameraAgente.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports